"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const uuid_1 = require("uuid");
const getFormatBatchItemStatus_1 = __importDefault(require("./getFormatBatchItemStatus"));
function groupBatchItem(orderBatchItems, name = '', setMenuIndex = 0, isSummary = false, groupByBatch = false) {
    const groupitemsByMenuId = lodash_1.default.groupBy(orderBatchItems, (item) => {
        const submitBatchItem = Object.assign(Object.assign({}, item), { options: lodash_1.default.orderBy(item.options, 'optionItemId') });
        return [groupByBatch ? item.batchId : '',
            item.menuId, (0, getFormatBatchItemStatus_1.default)(submitBatchItem, isSummary),
            item.isSet ? item.id : '',
            item.excludedOrderSurcharge,
            item.excludeOrderDiscount,
            item.setMenuIndex,
            item.price];
    });
    const currentItems = [];
    lodash_1.default.forEach(groupitemsByMenuId, (items, key) => {
        const updateValue = {};
        const ids = [];
        updateValue.itemIds = [];
        updateValue.ids = [];
        items.forEach(item => {
            var _a;
            updateValue.setMenuIndex = null;
            if (name !== '') {
                updateValue.setMenuIndex = setMenuIndex;
                updateValue.setName = name;
            }
            if (lodash_1.default.isEmpty(item.itemIds)) {
                ids.push(String((_a = item.id) !== null && _a !== void 0 ? _a : updateValue.id));
                if (item.quantity > 1) {
                    for (let i = 1; i < item.quantity; i++) {
                        ids.push(String((0, uuid_1.v4)()));
                    }
                }
                updateValue.ids = ids;
                updateValue.itemIds = ids;
            }
            else {
                updateValue.itemIds = updateValue.itemIds.concat(item.itemIds);
                updateValue.ids = updateValue.ids.concat(item.itemIds);
            }
            if (item.isSet) {
                const setItems = groupBatchItem(item.setItems, item.name, setMenuIndex);
                updateValue.setItems = setItems;
                updateValue.setMenuIndex = setMenuIndex;
                setMenuIndex += 1;
            }
        });
        const item = Object.assign(Object.assign(Object.assign({}, items[0]), { quantity: lodash_1.default.sumBy(items, 'quantity') }), updateValue);
        currentItems.push(item);
    });
    return currentItems;
}
exports.default = groupBatchItem;
//# sourceMappingURL=groupBatchItem.js.map